// Section 1
import { State, Action, StateContext, Selector, Select } from "@ngxs/store";
import { Group } from "../../model/group";
import {
  Checked,
  FetchGroups,
  GroupFilter,
  GroupSort,
} from "../actions/groups.action";

import { GroupsService } from "../../services/groups.service";
import { SearchAndSortArray } from "../../model/searchAndSortArray";
import { Injectable } from "@angular/core";

export class GroupStateModel {
  groups: Group[];
  selectedGroupIDs: number[];
  sortBy: string;
  direction: number;
  searchString: string;
  filterByList: string[];
  exactMatch: boolean;
}

@State<GroupStateModel>({
  name: "groups",
  defaults: {
    groups: [],
    selectedGroupIDs: [],
    sortBy: "",
    direction: 1,
    searchString: "",
    filterByList: ["name", "city", "state"],
    exactMatch: false,
  },
})
@Injectable()
export class GroupState {
  constructor(private service: GroupsService) {}

  @Selector()
  static getGroups(state: GroupStateModel) {
    state.groups.map((a) => {
      if (state.selectedGroupIDs.indexOf(a.group_id) > -1) {
        a.selected = true;
      }
    });

    let obj = new SearchAndSortArray(
      state.groups,
      state.filterByList,
      state.searchString,
      state.exactMatch,
      state.sortBy,
      state.direction
    );
    let groups = obj.search();
    groups = obj.sort();
    return groups;
  }

  @Action(FetchGroups)
  getPosts({ getState, setState }: StateContext<GroupStateModel>) {
    const state = getState();
    let posts: Group[] = [];

    this.service.getAllGroups().subscribe((x) => {
      setState({ ...state, groups: x });
    });
  }

  @Action(Checked)
  check(
    { getState, patchState }: StateContext<GroupStateModel>,
    { payload }: Checked
  ) {
    let st = getState().selectedGroupIDs;
    let idx = st.indexOf(payload);

    if (idx === -1) {
      st.push(payload);
    } else {
      st.splice(idx, 1);
    }

    patchState({ selectedGroupIDs: st });
  }

  @Selector()
  static getSelectedGroupIDs(state: GroupStateModel) {
    return state.selectedGroupIDs;
  }

  @Action(GroupSort)
  GroupSort(
    { getState, patchState }: StateContext<GroupStateModel>,
    { payload }: GroupSort
  ) {
    let state = getState();
    let sortBy = state.sortBy;
    let direction = state.direction;

    if (sortBy === payload) {
      direction = direction * -1;
    } else {
      direction = 1;
    }

    patchState({ sortBy: payload, direction });
  }

  @Selector()
  static getSortField(state: GroupStateModel) {
    return state.sortBy;
  }

  @Selector()
  static getSortDirection(state: GroupStateModel) {
    return state.direction === 1 ? "sort-asc" : "sort-desc";
  }

  @Action(GroupFilter)
  GroupFilter(
    { getState, patchState }: StateContext<GroupStateModel>,
    { payload }: GroupFilter
  ) {
    let state = getState();
    let filterByList = payload.filterByList.split(",");
    let exactMatch = payload.exactMatch;
    let searchString = payload.searchString;
    patchState({ filterByList, searchString, exactMatch });
  }
}
